<section class="why-we-different bg-F7F5F4">
  <div class="container">
    <div class="section-title">
      <h2>Nuestra Filosofía <span>Institucional</span></h2>
    </div>

    <div class="philosophy-list">
      @for (item of philosophyItems; track item) {
        <article
          class="philosophy-card"
          [class.philosophy-card--left]="item.alignment !== 'right'"
          [class.philosophy-card--right]="item.alignment === 'right'">
          <img [src]="item.imageUrl" [alt]="item.title" loading="lazy">
          <div class="philosophy-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </article>
      }
    </div>
  </div>
</section>
